import createLucideIcon from '../createLucideIcon';

const ArrowLeftToLine = createLucideIcon('ArrowLeftToLine', [
  ['line', { x1: '7', x2: '21', y1: '12', y2: '12', key: 'rq4vvj' }],
  ['polyline', { points: '13 6 7 12 13 18', key: '6iyxwj' }],
  ['path', { d: 'M3 19V5', key: 'rwsyhb' }],
]);

export default ArrowLeftToLine;
